<template>
  <d2-container>

    <template slot="header">
      <div class="overview">
      <div class="header" flex="main:justify">
        <div flex="cross:center">
          <div class="header__line"></div>
          <div class="header__title"> 数据统计  <el-popover
                  placement="top-start"
                  title="温馨提示"
                  width="400"
                  trigger="hover"
          >
            <li>显示自己和下级的交易总额和佣金总额</li>
            <el-button
                    slot="reference"
                    size="mini"
                    icon="el-icon-question"
            ></el-button>
          </el-popover>        仅统计近一年的数据</div>

        </div>
      </div>
      <div class="overview__row" flex="box:mean">
        <div class="overview__col" flex="dir:top cross:center">
          <div class="overview__title">交易总额</div>
          <div>{{yx_order_amount}}/{{yx_yj_amount}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center" >
          <div class="overview__title">微信交易金额/佣金总额</div>
          <div>{{wx_num_amount}}/{{wx_yj_amount}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center" >
          <div class="overview__title">支付宝交易金额/佣金总额</div>
          <div>{{zfb_num_amount}}/{{zfb_yj_amount}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center">
          <div class="overview__title">随行付交易金额/佣金总额</div>
          <div>{{sxf_num_amount}}/{{sxf_yj_amount}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center" >
          <div class="overview__title">乐刷交易金额/佣金总额</div>
          <div>{{fy_num_amount}}/{{fy_yj_amount}}</div>
        </div>
      </div>
      </div>
      <el-form
              :model="searchForm"
              ref="searchForm"
              label-width="10px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"
      >
        <el-form-item

        >

          <div flex="cross:center">
            <div class="header__line"></div>
            <div class="header__title">  结算清单 <el-popover
                    placement="top-start"
                    title="温馨提示"
                    width="400"
                    trigger="hover"
            >
              <li>显示给下级结算/未结算的佣金</li>
              <el-button
                      slot="reference"
                      size="mini"
                      icon="el-icon-question"
              ></el-button>
            </el-popover>已结算：{{js_amount}}元,未结算：{{wjs_amount}}元</div>
          </div>
        </el-form-item
>
      </el-form>
      <el-divider></el-divider>
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

<!--
        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.js_state"
                  placeholder="结算状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item
                label="姓名"
                prop="noticeTitle"
        >
          <el-input
                  v-model="searchForm.agent_name"
                  placeholder="姓名"
                  style="width: 100px;"
          />
        </el-form-item>





        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
          <el-button
                  type="primary"
                  @click="handleExportFormSubmit"
          >
            <d2-icon name="share" /> 导出
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
            v-if="multipleSelection.length>0"
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="batchDel"
    >
      批量结算
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商家/个人"
      >
        <template slot-scope="scope">
          {{scope.row.agent_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="姓名"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>

      <el-table-column
              label="类型"
      >
        <template slot-scope="scope">


          <div v-if="scope.row.dl_type=='0'">
            全国代理
          </div>
          <div v-else-if="scope.row.dl_type=='5'">
            运营中心
          </div>
          <div v-else-if="scope.row.dl_type=='1'">
            运营商
          </div>
          <div v-else-if="scope.row.dl_type=='2'">
            服务商
          </div>
          <div v-else-if="scope.row.dl_type=='4'">
            商家
          </div>
        </template>
      </el-table-column>



      <el-table-column
        label="佣金生成时间"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.order_time}}
        </template>
      </el-table-column>
      <el-table-column
              label="佣金总额"
              width="130"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.yx_yj_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="微信佣金总额"
              width="150"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.wx_yj_amount}}
        </template>
      </el-table-column>
      <el-table-column
            label="支付宝佣金总额"
            width="160"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
      {{scope.row.zfb_yj_amount}}
      </template>
    </el-table-column>
      <el-table-column
              label="随行付佣金总额"
              width="160"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.sxf_yj_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="富友佣金总额"
              width="160"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
        {{scope.row.fy_yj_amount}}
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="350"
      >
          <template slot-scope="scope">
            <el-button type="primary" plain  size="mini"  @click="openEditForm(scope.row)">线下收入明细</el-button>
            <el-button type="primary" plain  size="mini"  @click="openEditzfForm(scope.row)">纯支付分润明细</el-button>
            <el-button type="primary" plain  size="mini"  @click="openEdittxForm(scope.row)">奖励明细</el-button>


          </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
            :agent="agent"
            :pickerValue2="pickerValue2"
            :pickerValue3="pickerValue3"
            v-model="editFormVisible"
            @submit="getTableData"
    />

    <editzf-form
            :agent="agent"
            :pickerValue2="pickerValue2"
            :pickerValue3="pickerValue3"
            v-model="editzfFormVisible"
            @submit="getTableData"
    />

    <edittx-form
            :agent="agent"
            :pickerValue2="pickerValue2"
            :pickerValue3="pickerValue3"
            v-model="edittxFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as noticeService from "@/api/sys/notice";
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
import editForm from "./editForm"
import editzfForm from "./editzfForm"
import edittxForm from "./edittxForm"
export default {
  name: "CommissionPage",
  components: { editForm,editzfForm,edittxForm },
  data() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
    return {
      searchForm: {
          js_state: "",
          agent_name:""
      },
        js_amount:"",
        wjs_amount:"",
        yx_order_amount:"",
        wx_num_amount:"",
        zfb_num_amount:"",
        sxf_num_amount:"",
        fy_num_amount:"",
        yx_yj_amount:"",
        wx_yj_amount:"",
        zfb_yj_amount:"",
        sxf_yj_amount:"",
        fy_yj_amount:"",
        dateRange: [start, end],
        pickerOptions:{},
      loading: false,
      tableData: [],
        tableData2: [],
      multipleSelection: [],
        pickerValue2:'',
        pickerValue3:'',
        typeOptions: [
            {
                value: "结算",
                label: "结算"
            },
            {
                value: "未结算",
                label: "未结算"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        agent: {},
      editzfFormVisible: false,
      edittxFormVisible: false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
      this.getTableDataYj();
      this.getTableDataJs();
  },
  methods: {
      getTableDataYj(){
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",util.cookies.get('agentid'));
          formData4.append("xt_id",util.cookies.get('xt_id'));
          formData4.append("dl_type",util.cookies.get('dl_type'));
          agentService.getStatisticsOrderListYj(formData4).then(data => {
              if(data!=null && data!=""){
                  this.one_agent_num=data.one_agent_num;
                  this.yx_order_amount=data.yx_order_amount;
                      this.wx_num_amount=data.wx_num_amount;
                      this.zfb_num_amount=data.zfb_num_amount;
                      this.sxf_num_amount=data.sxf_num_amount;
                      this.fy_num_amount=data.fy_num_amount;
                      this.yx_yj_amount=data.yx_yj_amount;
                      this.wx_yj_amount=data.wx_yj_amount;
                      this.zfb_yj_amount=data.zfb_yj_amount;
                      this.sxf_yj_amount=data.sxf_yj_amount;
                      this.fy_yj_amount=data.fy_yj_amount;


              }
          });
      },
      getTableDataJs(){
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",util.cookies.get('agentid'));
          formData4.append("xt_id",util.cookies.get('xt_id'));
          formData4.append("dl_type",util.cookies.get('dl_type'));
          agentService.getStatisticsOrderListJs(formData4).then(data => {
              if(data!=null && data!=""){
                  this.js_amount=data.js_amount;
                  this.wjs_amount=data.wjs_amount;



              }
          });
      },
      dateConversion(value) {
          if (value != null && value != "") {
            var d = new Date(value);
            //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
            var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            console.info("===========date=========" + date);
            return date;
          }else{
            return "";
          }
      },
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          start_time:this.dateConversion(this.dateRange[0]),
          end_time:this.dateConversion(this.dateRange[1]),
          agentid: util.cookies.get('agentid'),
          xt_id: util.cookies.get('xt_id'),
          dl_type: util.cookies.get('dl_type'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getMobileOrderPagedlistSettlementXq(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
      handleSearchFormReset() {
          this.getTableData();
      },
      handleExportFormSubmit() {
        window.location.href=encodeURI(process.env.VUE_APP_API+"/moblieapp/settlementtoExcel?agentid="+util.cookies.get("agentid")+"&start_time="+this.dateConversion(this.dateRange[0])+"&end_time="+this.dateConversion(this.dateRange[1])+"&agent_name="+ this.searchForm.agent_name+"&js_state="+this.searchForm.js_state+"&xt_id="+util.cookies.get("xt_id")+"&dl_type="+util.cookies.get("dl_type"));
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
      openEditForm(agent) {
          this.agent = agent;
          this.pickerValue2=agent.order_time;
          this.pickerValue3=agent.order_time;;
          this.editFormVisible = true;
      },
    openEditzfForm(agent) {
      this.agent = agent;
      this.pickerValue2=agent.order_time;
      this.pickerValue3=agent.order_time;;
      this.editzfFormVisible = true;
    },
    openEdittxForm(agent) {
      this.agent = agent;
      this.pickerValue2=agent.order_time;
      this.pickerValue3=agent.order_time;;
      this.edittxFormVisible = true;
    },

      batchDel() {
        let msg = "批量结算";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {

          agentService
              .updateRelationBatch({
                  ids: JSON.stringify(this.multipleSelection.map(s => s.mer_order_id))
              })
              .then(() => {
                  this.getTableData();
              });

      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .header {
    font-size: 0.18rem;
    padding: 10px 0;
    border-bottom: 1px solid #ebeef5;
    &__line {
      width: 3px;
      background: rgb(16, 142, 233);
      height: 0.13rem;
      margin: 0 10px;
    }
  }
  .overview {
    width: 100%;
    border-radius: 10px;
    height: 1.3rem;
    min-height: 110px;
    &__col {
      font-size: 0.15rem;
      margin-top: 15px;
    }
    &__col:not(:last-child){
      border-right: 1px solid rgb(242, 242, 242);
    }
    &__title {
      color: rgb(137, 149, 160);
      margin-bottom: 10px;
    }
  }

</style>
